import { useEventListener } from '../../hooks/useEventListener';
import React, { useState } from 'react';

type Props = {
    errorMessage?: string;
    onClick?: () => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: () => void;
    onFocusOut?: () => void;
    code?: string;
    error?: boolean;
    text?: string;
    additionalMessage?: string;
    isNumber?: boolean;
    commonMistake?: boolean;
    commonMistakeMessage?: string;
    maxLength?: number;
};

export default function CodeInput(props: Props) {
    const [dragging, setDragging] = useState(false);

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        if (!dragging) {
            props.onClick && props.onClick();
        }
        setDragging(false);
    };

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!dragging) {
            props.onClick && props.onClick();
        }
        setDragging(false);
    };

    function submitHandler(e: React.FormEvent<HTMLInputElement>) {
        e.preventDefault();
    }

    function focusinHandler() {
        if (props.onFocus) {
            props.onFocus();
        }
    }

    function focusoutHandler() {
        if (props.onFocusOut) {
            props.onFocusOut();
        }
    }

    useEventListener('submit', submitHandler);
    useEventListener('focusout', focusoutHandler);

    return (
        <div className="code-input">
            <div className="code-input__container">
                {props.error && <div className="code-input__error">{props.errorMessage}</div>}
                {props.commonMistake && <div className="code-input__error">{props.commonMistakeMessage}</div>}
                {props.additionalMessage && <div className="code-input__info">{props.additionalMessage}</div>}
                <form className="code-input__form" action="">
                    <input
                        autoFocus={false}
                        onFocus={focusinHandler}
                        className="code-input__form-input"
                        placeholder={props.text ? props.text : 'Kód'}
                        type={props.isNumber ? 'number' : 'text'}
                        value={props.code}
                        onChange={props.onChange}
                        maxLength={props.maxLength || 10}
                    />
                    <label className="code-input__label" htmlFor="checkbox">
                        <div
                            className="code-input__button"
                            onTouchStart={() => {
                                setDragging(false);
                            }}
                            onTouchMove={() => {
                                setDragging(true);
                            }}
                            onTouchEnd={handleTouch}
                            onClick={handleClick}
                        >
                            OK
                        </div>
                    </label>
                </form>
            </div>
        </div>
    );
}
